import React, { useId } from "react";
import { canonicalCity, citiesForCountry } from "./cities";
import { Input } from "./ui";

export default function CityInput({
  countryCode,
  value,
  onChange,
  label = "Ciudad",
  testId = "city-input",
  error,
}) {
  const reactId = useId();
  const listId = `pawcita-cities-${String(countryCode || "PA").toLowerCase()}-${reactId.replace(/:/g, "")}`;

  const handleBlur = () => {
    const canonical = canonicalCity(countryCode, value);
    if (canonical !== value) onChange(canonical);
  };

  return (
    <div>
      <Input
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        list={listId}
        placeholder="Busca o escribe tu ciudad"
        maxLength={100}
        testId={testId}
        error={error}
        autoComplete="address-level2"
      />
      <datalist id={listId}>
        {citiesForCountry(countryCode).map((city) => (
          <option key={city} value={city} />
        ))}
      </datalist>
      <p className="mt-1 text-xs text-slate-400">
        Selecciona del listado o escribe otra ciudad si no aparece.
      </p>
    </div>
  );
}
